<template>
  <section id="step1" class="p-content-plan-manual-step">
    <div class="l-container">
      <h2 class="c-title--x-large">
        STEP1 キーワードの検索意図を理解する
      </h2>
      <div class="l-rows">
        <p>
          コンテンツSEOにおいて重要なことは、ユーザーの検索意図に対してユーザーの期待以上のコンテンツを提供することです。<br />
          上位サイトの良いポイントをただ真似るだけでなく、<strong>「ユーザーは何を実現したくてこのキーワードで検索しているのか」を分析・理解した上で執筆する</strong>ことで、ユーザーにとって価値がある＝上位表示されやすいコンテンツを作成することが可能です。
        </p>
        <p>
          上位サイトのタイトル・見出しテキストや実際のページの内容を参考に、<strong
            >ユーザーが「{{
              keyword
            }}」というキーワードで検索する際の状況や心情</strong
          >を整理しましょう。
        </p>
        <div class="c-panel">
          <ul class="c-list--disc">
            <li>
              どのような人が？<span class="c-text--small c-text--note l-ml-3"
                >例：知識や経験が少ないSEO担当者</span
              >
            </li>
            <li>
              いつ？<span class="c-text--small c-text--note l-ml-3"
                >例：上長からSEO対策の予算が削減されることを聞いた後</span
              >
            </li>
            <li>
              どこで？<span class="c-text--small c-text--note l-ml-3"
                >例：職場で同僚と話しながら</span
              >
            </li>
            <li>
              どのデバイスで？<span class="c-text--small c-text--note l-ml-3"
                >例：ノートPC</span
              >
            </li>
            <li>
              どのような目的で？<span class="c-text--small c-text--note l-ml-3"
                >例：現在はSEO対策を外注しているが、内製化のための具体的な手段や方法を知りたい</span
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    keyword: {
      type: String,
      required: true
    }
  }
};
</script>
